// CustomerLayout.js
import React, { useState, useEffect } from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';

const CustomerLayout = () => {
  const { customerId } = useParams(); 
  const [dataClient, setDataClient] = useState(null);
  const [error, setError] = useState(null);
  console.log('CustomerLayout customerId:', customerId); // Debugging line

  useEffect(() => {
    if (!customerId) return;

    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_PROXY_URL}/api/customer/manage/${customerId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (response.status === 404 || response.status === 403 || response.status === 500) {
          setError('not-found');
          localStorage.setItem('customer_number', customerId); // Ensure fallback
          return;
        }

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        setDataClient(data);
        localStorage.setItem('customer_number', customerId); // Store on success too
      } catch (err) {
        console.error('CustomerLayout fetch error:', err);
        setError('error');
      }
    };

    fetchData();
  }, [customerId]);

  if (error === 'not-found') {
    return <Navigate to={`/customer/${customerId}/not-found`} replace />;
  }

  if (error === 'error') return <div>Error loading customer data.</div>;
  if (!dataClient) return <div>Loading customer data...</div>;

  return <Outlet context={{ customerId, dataClient }} />;
};

export default CustomerLayout;